export default __webpack_public_path__ + "static/media/icon-error-large.0867e0a7.png";